export const ANALYTICS_EVENT_TYPE = {
  VIEW: 'View',
  ADD_TO_CART: 'AddToCart',
  REMOVE_FROM_CART: 'RemoveFromCart',
  PURCHASE: 'Purchase',
  IMPRESSION: 'Impression',
  CLICK: 'Click',
  HOME_PAGE_VIEW: 'HomePageView',
  BROWSING: 'Browsing',
  LOGIN: 'Login',
  SIGNUP: 'Signup',
  CUSTOM: 'Custom',
} as const;

export type AnalyticsEventType =
  (typeof ANALYTICS_EVENT_TYPE)[keyof typeof ANALYTICS_EVENT_TYPE];

export type AnalyticsService = 'ga4' | 'amplitude' | 'klaviyo' | 'bigquery';

export interface ConsentState {
  analyticsStorage: 'granted' | 'denied';
  adStorage: 'granted' | 'denied';
}

export interface ProductContext {
  id?: string;
  quantity?: number;
  variant?: string;
}

export interface CheckoutContext {
  orderId?: string;
  total?: number;
  currency?: string;
  subtotal?: number;
  discount?: number;
  couponCode?: string;
  paymentType?: string;
  shippingMethod?: string;
  shippingCost?: number;
  cartProducts?: ProductContext[];
}

export interface InteractionContext {
  authenticationMethod?: string;
  buttonName?: string;
  sectionName?: string;
  filterValues?: Record<string, unknown>;
}

export interface CustomEventContext {
  ga4EventName?: string;
  amplitudeEventName?: string;
  params?: Record<string, unknown>;
}

export interface AnalyticsContext {
  clientId?: string;
  userId?: string;
  pagePath?: string;
  pageTitle?: string;
  pageReferrer?: string;
  pageType?: string;
  platform?: 'web' | 'app';
  consent?: ConsentState;
  product?: ProductContext;
  checkout?: CheckoutContext;
  interaction?: InteractionContext;
  customEvent?: CustomEventContext;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
}

export interface AnalyticsEventRequest {
  actorId: string;
  eventType: AnalyticsEventType;
  analytics: AnalyticsContext;
  services?: AnalyticsService[];
  productId?: string;
  orderId?: string;
}
